import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import DataLayer from '../common/data-layer.js';
import Image from '../common/image.js';
import Link from '../common/link.js';
import style from './card.style.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
var _excluded = ["color", "topic", "onAction"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Card = function Card(_ref) {
  var color = _ref.color,
      topic = _ref.topic,
      onAction = _ref.onAction,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  if (topic.detail) {
    return jsx(DataLayer, {
      selector: "[Card]#".concat(topic.id),
      triggers: ['click'],
      context: {
        topic: topic
      },
      render: function render(ref) {
        return jsxs("div", _objectSpread(_objectSpread({
          ref: ref,
          css: style.card,
          onClick: function onClick() {
            return setActive(!active);
          }
        }, props), {}, {
          children: [jsx(Image, {
            css: style.image,
            mode: "contain",
            image: topic.image
          }), jsx("div", {
            css: style.title(active),
            children: topic.name
          }), jsx(Collapse, {
            "in": active,
            children: jsx("div", {
              children: jsx("div", {
                css: style.description,
                children: topic.detail
              })
            })
          }), jsx("div", {
            css: style.button(color),
            children: jsx(FormattedMessage, {
              id: "clickHere",
              defaultMessage: "Click",
              values: {
                active: active
              }
            })
          })]
        }));
      }
    });
  }

  if (topic.action) {
    return jsx(DataLayer, {
      selector: "[Card]#".concat(topic.id),
      triggers: ['click'],
      context: {
        topic: topic
      },
      render: function render(ref) {
        return jsxs("div", _objectSpread(_objectSpread({
          ref: ref,
          css: style.card,
          onClick: function onClick() {
            return onAction(topic.action);
          }
        }, props), {}, {
          children: [jsx(Image, {
            css: style.image,
            mode: "contain",
            image: topic.image
          }), jsx("div", {
            css: style.title(active),
            children: topic.name
          }), jsx("div", {
            css: style.button(color),
            children: topic.actionText
          })]
        }));
      }
    });
  }

  return jsx(DataLayer, {
    selector: "[Card]#".concat(topic.id),
    triggers: ['click'],
    context: {
      topic: topic
    },
    render: function render(ref) {
      return jsxs(Link, _objectSpread(_objectSpread({
        ref: ref,
        css: style.card,
        link: topic.link
      }, props), {}, {
        children: [jsx(Image, {
          css: style.image,
          mode: "contain",
          image: topic.image
        }), jsx("div", {
          css: style.title(active),
          children: topic.name
        }), jsx("div", {
          css: style.button(color),
          children: jsx(FormattedMessage, {
            id: "clickHere",
            defaultMessage: "Click"
          })
        })]
      }));
    }
  });
};

export { Card as default };